<template>
  <div class="modal fade" :id="modalId" tabindex="-1" :aria-labelledby="`${modalId}Label`" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" :id="`${modalId}Label`">重複登録の確認</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="close"></button>
        </div>
        <div class="modal-body">
          <p class="mb-2">{{ message }}</p>
          <p class="text-muted small mb-0">重複登録が必要な場合のみ作成してください。</p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" @click="close">キャンセル</button>
          <button type="button" class="btn btn-warning" data-bs-dismiss="modal" @click="confirm">作成する</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    modalId: {
      type: String,
      required: true
    },
    message: {
      type: String,
      default: 'すでに同名のものが登録されていますが、本当に作成してもよろしいでしょうか？'
    }
  },
  emits: ['confirm', 'close'],
  methods: {
    confirm() {
      this.$emit('confirm');
    },
    close() {
      this.$emit('close');
    }
  }
};
</script>
